function filterQuotes(quotes, { excludePartners } = {}) {
  if (excludePartners) {
    return quotes.filter((quote) => !quote.partner);
  }
  return quotes;
}

export default filterQuotes;
